import React from "react";
import Tabs from "../../../../../Component/DigitalMarketing/Tabs";
import Details from "./Details";

interface LayoutProps {
  setActive: (id: number) => void;
  active: number;
  children: () => React.ReactNode;
  customerId: string;
  CustomerData:any
 
}

const Layout: React.FC<LayoutProps> = ({
  setActive,
  active,
  children,
  customerId,
  CustomerData
}) => {
  const tabValues = [
    { id: 1, name: "Appointment History" },
    // { id: 2, name: "Treatments" },
    { id: 3, name: "Pregnancy" },
    { id: 4, name: "Prescriptions" },
    { id: 5, name: "Progress Notes" },
    { id: 6, name: "Special Notes" },
    { id: 7, name: "Reports" },
    { id: 8, name: "Billing" },
    { id: 9, name: "Care Packages" },
    //  { id: 10, name: "USG Follicular Study" },
  ];

  return (
    <div className="ms-1">
      {/* Tabs Section */}
      <div>
        <Tabs tablist={CustomerData?.sex.toLowerCase()==='female'?tabValues:tabValues.filter((val)=>val.name!=='Pregnancy')} active={active} setActive={setActive} />
      </div>

      {/* Layout with Details and Main Content */}
      <div className="row gap-1">
        {/* Sidebar (Details Component) */}
        <div
          className="col-3 card ms-2"
          style={{ maxHeight: "80vh", overflowY: "auto" }}
        >
          <Details id={customerId} />
        </div>

        {/* Main Content Area */}
        <div
          className="col-8-5"
          style={{ maxHeight: "80vh", overflowY: "auto" }}
        >
          {children()}
        </div>
      </div>
    </div>
  );
};

export default Layout;
